import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// MFA gate: when the backend answers 401 "mfa_required", open the global
// 2-step verification dialog (handled by <MfaGate/>). /mfa/* calls are exempt.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && err.response?.data?.detail === "mfa_required" &&
        !String(err.config?.url || "").includes("/mfa/")) {
      window.dispatchEvent(new CustomEvent("tp:mfa-required"));
    }
    return Promise.reject(err);
  }
);

export default api;
